module.exports = __webpack_public_path__ + "img/brand-mitsubishi.8b7858fe.png";